import media from '@oneflare/flarekit/lib/libs/media';
import NextImage from 'next/image';
import { styled, css, ExecutionContext } from 'styled-components';

import { publicRuntimeConfig } from 'lib/utils/Environment';

const clsFontStackLabel = '\'Helvetica Neue\', Arial, sans-serif';
const isOneflareDomain = publicRuntimeConfig.DOMAIN === 'oneflare';

export type Kind = 'light' | 'primary';

export const HeroStyled = styled.section<{
  $kind?: Kind;
}>`
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  padding: 32px 20px 40px;
  position: relative;
  z-index: ${({ theme }) => theme.zIndex[0]};
  ${({ theme }) => `background: ${theme.color.white}`};
  ${({ $kind }) => $kind === 'light' && 'padding: 57px 32px 87px;'};
  ${media.mdUp`
    padding: 32px 32px 48px;
    min-height: 430px;
  `}
`;

export const HeroImage = styled(NextImage)`
  z-index: -1;
  ${media.mdDown`
    display: none !important;
  `}
`;

export const HeroContentStyled = styled.section`
  align-items: center;
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 100%;
`;

export const SearchStyled = styled.form<{
  $kind?: Kind;
}>`
  background-color: ${({ theme }) => theme.color.white};
  border: 6px solid ${({ theme }) => theme.color.primary};
  text-align: center;
  margin: 16px auto 0;
  max-width: 100%;
  min-width: 100%;
  padding: 32px 24px;
  ${({ $kind }) => $kind === 'light' && (
    css`
      background-color: rgba(255, 255, 255, 70%);
      border: none;
      border-radius: 4px;
      box-shadow: 1px 1px 5px 2px rgba(128, 130, 133, 20%);
      padding: 24px 40px 32px;
      margin: 40px auto 0;
      max-width: 550px;
   `)}

  ${media.mdUp`
    margin: 32px auto 0;
    max-width: 750px;
    min-width: 580px;
    padding: 32px 56px 40px;
  `}
`;

export const JobFormLeadStyled = styled.section`
  color: ${({ theme }) => theme.color.gunMetal};
  display: block;
  font-family: ${({ theme }) => theme.font.primaryRegular};
  font-size: 16px;
  margin: 0 auto 16px;
  max-width: 450px;
  position: relative;
  top: 24px;
`;

export const LabelStyled = styled.label<{
  $kind?: Kind;
}>`
  color: ${({ theme }) => theme.color.charcoal};
  display: block;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.5;
  margin: 0 auto 24px;
  font-family: ${({ theme }) => (isOneflareDomain ? clsFontStackLabel : theme.font.primaryRegular)};

  ${({ $kind, theme }) => $kind === 'light' && (css`
    color: ${theme.color.tertiary};
    font-size: 14px;
    text-align: left;
    margin-bottom: 6px;
  `)}

  ${media.mdUp`
    font-size: 28px;

    ${({ $kind, theme }: ExecutionContext & {
      $kind?: Kind
    }) => $kind === 'light' && (css`
      color: ${theme.color.tertiary};
      font-size: 18px;
      line-height: 27px;
      margin: 0 auto 22px;
    `)}
  `}
`;

export const TitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  align-items: center;
`;
